import Streaks from '../vanilla/streaks';
import getCurrentStreak from './getCurrenStreak';
import getLast7Days from './getLast7Days';

function formatLevel(level: string): string {
  return level
    .split(':')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export default async function updateStreakDisplay(
  gameKey: string,
  level: string,
): Promise<void> {
  const streaks = await Streaks.getStreaks(gameKey, level);

  if (streaks?.length) {
    const streak = streaks[streaks.length - 1];

    const playStreak = document.querySelector('#current-streak');
    const streakDisplay =
      streak && streak?.current_win_streak >= 1
        ? `🔥 ${streak.current_win_streak}`
        : `🥶 0`;

    if (playStreak) {
      playStreak.textContent = streakDisplay;
    }
  }
}

export async function updateNavbarForLevel(
  gameKey: string,
  level: string,
): Promise<void> {
  // Update the level label with formatted level
  const levelLabel = document.querySelector('.dropdown-content p');
  if (levelLabel) {
    levelLabel.textContent = `Your ${formatLevel(level)} Play Streak`;
  }

  // Get fresh streak data for the new level
  const today = new Date();
  const sevenDaysAgo = new Date();
  const since = new Date(sevenDaysAgo.setDate(today.getDate() - 7))
    .toISOString()
    .split('T')[0];

  const [streakLogs = [], streaks = []] = await Promise.all([
    Streaks.getLogs(gameKey, level, since, 'win'),
    Streaks.getStreaks(gameKey, level),
  ]);

  const currentStreak = getCurrentStreak(streaks);

  // Update the current streak display
  const playStreak = document.querySelector('#current-streak');
  const streakDisplay =
    currentStreak && currentStreak >= 1 ? `🔥 ${currentStreak}` : `🥶 0`;

  if (playStreak) {
    playStreak.textContent = streakDisplay;
  }

  // Update the 7-day visualization
  const streakDaysContainer = document.querySelector('#days');
  if (streakDaysContainer) {
    const streakDaysHTML = getLast7Days()
      .map((day, i) => {
        const isStreakDay = streakLogs.includes(day);
        const isCurrentDay = i === 6;
        return `<div class="day ${
          isStreakDay ? (isCurrentDay ? 'streakCurrentDay' : 'streak') : ''
        }">
                    ${day.split('-')[2]}
                  </div>`;
      })
      .join('');
    streakDaysContainer.innerHTML = streakDaysHTML;
  }
}
